import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { DiplomaDigital } from "../models/diploma-digital";
import { BuscaService } from "../services/busca.service";
import { DadosRegistro } from "../models/dadosRegistro";
import { DadosCurso } from "../models/dadosCurso";
import { DadosIes } from "../models/dadosIes";

import { parseString } from "xml2js";

@Component({
  selector: "app-diploma",
  templateUrl: "./diploma.component.html",
  styleUrls: ["./diploma.component.scss"],
  standalone: false,
})
export class DiplomaComponent implements OnInit {
  dadosDiplomaOpen: boolean[] = [false, false, false];
  opened = 0;
  pdf: SafeResourceUrl;
  xmlDownloadLink: SafeResourceUrl;
  pdfDownloadLink: SafeResourceUrl;
  xmlFile: string;
  codigo = "";
  dadosRegistro: DadosRegistro;
  dadosCurso: DadosCurso;
  dadosIES: DadosIes;
  user: DiplomaDigital;
  semXML = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _busca: BuscaService,
    private domSanitizer: DomSanitizer
  ) {
    this.dadosCurso = new DadosCurso();
    this.dadosRegistro = new DadosRegistro();
    this.dadosIES = new DadosIes();
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((paramMap) => {
      this.codigo = paramMap.get("id");
    });

    const diplomaDigital = JSON.parse(
      sessionStorage.getItem("diplomaDigital")
    );
    const codDiploma = diplomaDigital
      ? diplomaDigital.codValidacaoDiploma
      : "";

    if ("diplomaDigital" in sessionStorage && codDiploma === this.codigo) {
      this.user = JSON.parse(sessionStorage.getItem("diplomaDigital"));
      if (this.user.codXmlPublico != null) {
        this.ajeitarPdfXml();
        this.lerXML(atob(this.user.codXmlPublico));
      }

      // Se for Pós, Mestrado e Doutorado, não exibir botões do XML
      // 1 - Especialização(Pós) | 3 - Mestrado(Doutorado) | 4 - Graduação Tecnológica | 11 - Graduação | 45 - Mestrado
      if (this.user.codTipoCurso === 1 || this.user.codTipoCurso === 3 || this.user.codTipoCurso === 45) {
        this.semXML = true;
      }
    } else {
      if (this.codigo != "") {
        this._busca
          .getDiplomaDigital(this.codigo)
          .subscribe((response) => {
            this.user = response;

            // Se for Pós, Mestrado e Doutorado, não exibir botões do XML
            // 1 - Especialização(Pós) | 3 - Mestrado(Doutorado) | 4 - Graduação Tecnológica | 11 - Graduação | 45 - Mestrado
            if (this.user.codTipoCurso === 1 || this.user.codTipoCurso === 3 || this.user.codTipoCurso === 45) {
              this.semXML = true;
            }

            if (this.user) {
              sessionStorage.setItem(
                "diplomaDigital",
                JSON.stringify(this.user)
              );

              if (this.user.codXmlPublico != null) {
                this.ajeitarPdfXml();
                this.lerXML(atob(this.user.codXmlPublico));
              }
            } else {
              this.router.navigate([""]);
            }
          });
      } else {
        this.router.navigate([""]);
      }
    }
  }

  open(n: number) {
    if (this.dadosDiplomaOpen[n]) {
      this.dadosDiplomaOpen[n] = false;
    } else {
      this.dadosDiplomaOpen = [false, false, false];
      this.dadosDiplomaOpen[n] = true;
    }
  }

  ajeitarPdfXml() {
    const b64 = this.user.imgRvdd;
    this.pdf = this.getPDF(b64);
    this.xmlDownloadLink = this.domSanitizer.bypassSecurityTrustResourceUrl(
      "data:application/octet-stream;base64," + this.user.codXmlPublico
    );
    this.pdfDownloadLink = this.domSanitizer.bypassSecurityTrustResourceUrl(
      "data:application/octet-stream;base64," + b64
    );
  }

  getPDF(pdf: string) {
    const byteArray = new Uint8Array(
      atob(pdf)
        .split("")
        .map((char) => char.charCodeAt(0))
    );
    const blob = new Blob([byteArray], {
      type: "data:application/pdf",
    });

    return URL.createObjectURL(blob);
  }

  lerXML(xml: string) {
    const temp = decodeURIComponent(escape(xml));
    //const ps = parseString;
    let xmlDoc = null;

    parseString(temp, function (err, result) {
      xmlDoc = result;
    });

    this.dadosRegistro =
      xmlDoc.Diploma.infDiploma[0].DadosRegistro[0]?.IesRegistradora[0];
    this.dadosRegistro.LivroRegistro =
      xmlDoc.Diploma.infDiploma[0].DadosRegistro[0].LivroRegistro[0];
    this.dadosCurso =
      xmlDoc.Diploma.infDiploma[0].DadosDiploma[0].DadosCurso[0];
    this.dadosIES =
      xmlDoc.Diploma.infDiploma[0].DadosDiploma[0].IesEmissora[0];
  }

  //formataCPF(cpf) {
  //  const cpfAjustado = "0".repeat(11 - cpf.length) + cpf;
  //  return cpfAjustado;
  //}

  formataCPF(cpf: string | number) {
    return String(cpf).padStart(11, '0');
  }
}
